"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _lodash = _interopRequireDefault(require("lodash.isempty"));

var _components = require("../common/components");

var _Section = _interopRequireDefault(require("../components/Section"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function Styleguides(_ref) {
  var styleguidesOverview = _ref.styleguidesOverview,
      openAssetModal = _ref.openAssetModal,
      styleguides = _ref.styleguides,
      gotoId = _ref.gotoId,
      setRef = _ref.setRef;
  return _react.default.createElement(_Section.default, {
    className: "section__style-guide",
    gotoId: gotoId,
    setRef: setRef,
    icon: "guide",
    title: "Style guide",
    description: styleguidesOverview,
    emptyText: "Your company has not added a styleguide yet"
  }, (0, _lodash.default)(styleguides) ? null : styleguides.map(function (_ref2) {
    var subBrandGroupId = _ref2.subBrandGroupId,
        name = _ref2.name,
        assetIds = _ref2.assetIds;
    return (0, _lodash.default)(assetIds) ? null : _react.default.createElement(_react.Fragment, {
      key: subBrandGroupId
    }, _react.default.createElement("h2", null, name), _react.default.createElement("div", {
      className: "container"
    }, assetIds.map(function (assetId) {
      return _react.default.createElement(_commonReact.AssetSelector, {
        key: assetId,
        assetId: assetId
      }, function (asset) {
        if (!asset) {
          return _react.default.createElement(_components.AssetLoader, {
            assetId: assetId
          });
        }

        var _ref3 = asset || {},
            updatedAt = _ref3.updatedAt,
            title = _ref3.title,
            description = _ref3.description;

        return _react.default.createElement("div", {
          className: "section__style-guide__container"
        }, _react.default.createElement("div", {
          className: "section__style-guide__container__icon"
        }, _react.default.createElement(_uiKit.Icon, {
          width: 75,
          height: 75,
          size: 75,
          color: "russian",
          name: "document"
        }), _react.default.createElement("div", null, title && _react.default.createElement("h3", null, title), description && _react.default.createElement("p", null, description), _react.default.createElement("p", {
          className: "small"
        }, _react.default.createElement("span", null, "Last Updated:"), " ".concat((0, _moment.default)(updatedAt, 'x').format('DD MMM YYYY [at] h:ma z'))))), _react.default.createElement(_uiKit.Button, {
          className: "section__style-guide__container__button",
          type: "SECONDARY",
          onClick: openAssetModal(assetId),
          small: true
        }, "Preview"));
      });
    })));
  }).filter(Boolean));
}

var _default = (0, _react.memo)(Styleguides);

exports.default = _default;